import { ActionCreator } from "../types/store-types";
import {
    AuthActionTypes,
    InitUserRequestActionType,
    InitUserSuccessActionType,
    InitUserFailureActionType,
    SetUserTokenActionType,
    SetLoadingActionType,
    ClearErrorsActionType,
    MigrateGuestToUserRequestActionType,
    MigrateGuestToUserSuccessActionType,
    MigrateGuestToUserFailureActionType,
    GetCurrentUserRequestActionType,
    GetCurrentUserSuccessActionType,
    GetCurrentUserFailureActionType,
    InitUserActivationSuccessActionType,
    InitUserActivationFailureActionType,
    InitUserActivationRequestActionType,
} from "./types";

/* -- Init User Request Action -- */

export const initUserActivationRequest: ActionCreator<InitUserActivationRequestActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_ACTIVATION,
    payload,
});

export const initUserActivationSuccess: ActionCreator<InitUserActivationSuccessActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_ACTIVATION_SUCCESS,
    payload,
});

export const initUserActivationFailure: ActionCreator<InitUserActivationFailureActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_ACTIVATION_FAILURE,
    payload,
});

export const initUserRequest: ActionCreator<InitUserRequestActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_REQUEST,
    payload,
});

export const initUserSuccess: ActionCreator<InitUserSuccessActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_SUCCESS,
    payload,
});

export const initUserFailure: ActionCreator<InitUserFailureActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_FAILURE,
    payload,
});

export const getCurrentUserRequest: ActionCreator<GetCurrentUserRequestActionType> = payload => ({
    type: AuthActionTypes.GET_CURRENT_USER_REQUEST,
    payload,
});

export const getCurrentUserSuccess: ActionCreator<GetCurrentUserSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_CURRENT_USER_SUCCESS,
    payload,
});

export const getCurrentUserFailure: ActionCreator<GetCurrentUserFailureActionType> = payload => ({
    type: AuthActionTypes.GET_CURRENT_USER_FAILURE,
    payload,
});

export const setUserToken: ActionCreator<SetUserTokenActionType> = payload => ({
    type: AuthActionTypes.SET_USER_TOKEN,
    payload,
});

export const setAuthLoading: ActionCreator<SetLoadingActionType> = payload => ({
    type: AuthActionTypes.SET_LOADING,
    payload,
});

export const clearAuthErrors: ActionCreator<ClearErrorsActionType> = payload => ({
    type: AuthActionTypes.CLEAR_ERRORS,
    payload,
});

export const migrateUserRequest: ActionCreator<MigrateGuestToUserRequestActionType> = payload => ({
    type: AuthActionTypes.MIGRATE_GUEST_TO_USER_REQUEST,
    payload,
});

export const migrateUserSuccess: ActionCreator<MigrateGuestToUserSuccessActionType> = payload => ({
    type: AuthActionTypes.MIGRATE_GUEST_TO_USER_SUCCESS,
    payload,
});

export const migrateUserFailure: ActionCreator<MigrateGuestToUserFailureActionType> = payload => ({
    type: AuthActionTypes.MIGRATE_GUEST_TO_USER_FAILURE,
    payload,
});
